import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, hasRole } from "../utils/api";

export default function ProtectedRoute({ children, requiredRole = null, allowedRoles = null }) {
    // Check if user is authenticated
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    // Check if user has required role
    if (requiredRole && !hasRole(requiredRole)) {
        return <Navigate to="/home" replace />;
    }

    // Check if user has one of the allowed roles
    if (allowedRoles && !allowedRoles.some(role => hasRole(role))) {
        return <Navigate to="/home" replace />;
    }

    return children;
}
